import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "../auth/AuthContext.js";
import { HistoryTab } from "./generate/HistoryTab.js";

/**
 * FIX-045 — Admin: View external user/workspace History. Lets the
 * platform OWNER open ANY workspace's real History screen (same
 * component, same capabilities a customer sees) without logging in as
 * them and without SQL. Reuses `HistoryTab` unmodified except for its
 * `basePath` prop (see that file's own doc comment) — no duplicate
 * History UI, no second data model.
 *
 * The client-side `isPlatformOwner` check below is a UX nicety, not the
 * real security boundary: the actual data calls this page triggers
 * (`GET /videos/:tenantId`, `GET /videos/:tenantId/:videoId/progress`)
 * already enforce platform-OWNER-only cross-tenant access server-side,
 * in `requireTenantAccess` (packages/application/src/auth/authorize.ts)
 * — the same mechanism admin-routes.ts's other cross-tenant reads
 * (`/admin/videos/recent-cost`, `/admin/workspaces/:tenantId/personas`)
 * already rely on. A non-owner hitting this route directly still gets a
 * real 403 from the API, never just a hidden button.
 */
export function AdminWorkspaceHistoryPage() {
  const { user } = useAuth();
  const { tenantId } = useParams();

  if (!user?.isPlatformOwner) {
    return <Navigate to="/generate" replace />;
  }
  if (tenantId === undefined) {
    return <Navigate to="/admin" replace />;
  }

  return (
    <div>
      <div className="card" style={{ marginBottom: 12 }}>
        <a href="/admin">&larr; Back to Admin</a>
        <p className="muted" style={{ marginTop: 8 }}>
          Viewing history for workspace <code>{tenantId}</code> — an external workspace, not your own.
        </p>
      </div>
      <HistoryTab tenantId={tenantId} basePath={`/admin/workspaces/${encodeURIComponent(tenantId)}/history`} />
    </div>
  );
}
